import { Box, BoxProps } from '@qga/roo-ui/components';
import RefundBreakdown from 'components/RefundBreakdown';
import ExpandableBreakdown from '../ExpandableBreakdown';
import * as track from 'lib/gaTracking/changeDatesPageEvents';
import { FC } from 'react';
import { useChangeDates } from 'pages/ChangeDatesPage/ChangeDatesProvider';

const fontSize = 'base';
const titleStyle = {
  fontSize,
  color: '#333333',
};
const itemStyle = {
  fontSize,
  color: '#999999',
};

const RefundPayment: FC<BoxProps> = (props) => {
  const { amendment } = useChangeDates();
  return (
    <Box mb={4} {...props}>
      <ExpandableBreakdown
        toggleText="Refund breakdown"
        initiallyOpen
        textStyle={titleStyle}
        flexDirection="row"
        pb={3}
        onToggled={(isOpen: boolean) => track.togglePaymentBreakdown(isOpen)}
      >
        <RefundBreakdown
          breakdown={amendment!.amendmentTotal!.breakdown}
          penalty={[]}
          showHeading={false}
          titleStyle={titleStyle}
          itemStyle={itemStyle}
        />
      </ExpandableBreakdown>
    </Box>
  );
};

export default RefundPayment;
